<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'ven-produto-linha') {
            next({ name: 'ven-produto-linha-list' });
        } else if (to.name == 'linhas') {
            next({ name: 'pro-produto-linha-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'ven-produto-linha') {
            this.$router.push({ name: 'ven-produto-linha-list' });
        }

        if (this.$route.name == 'linhas') {
            this.$router.push({ name: 'pro-produto-linha-list' });
        }
    },
};
</script>
